module.exports = "<p>media works!</p>\n"